import { getLocalStorageValue } from '@/utils/common';

export const AUTH_CONFIG = {
  organizationId: process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID || process.env.NEXT_PUBLIC_PP_ORG_ID || '',
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL_AUTH || process.env.NEXT_PUBLIC_PP_API_BASE_URL || '',
  loginMethods: ['OTP', 'PASSWORD'],
  localStorageFallback: true,
  clientId: process.env.NEXT_PUBLIC_CLIENT_LOGIN_TYPE || 'system-admin',
  clientSecret: process.env.NEXT_PUBLIC_CLIENT_SECRET || '',
  contextIdentifier: 'TOKEN_CONTEXT',
  loginPageUrl:
    getLocalStorageValue('from_app') === 'true'
      ? '/app-logout'
      : `/login?redirectUrl=${encodeURIComponent(
          typeof window !== 'undefined' ? window.location.pathname + window.location.search : ''
        )}`,
  redirectUrl: '/app-logout',
  debugMode: process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_ENV === 'staging',
};
